import { render } from "./co2Detail.vue?vue&type=template&id=6a27eb97&scoped=true"
import script from "./co2Detail.vue?vue&type=script&lang=js"
export * from "./co2Detail.vue?vue&type=script&lang=js"

import "./co2Detail.vue?vue&type=style&index=0&id=6a27eb97&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a27eb97"]])

export default __exports__